/* eslint-disable */
import Socket from "@/assets/js/websocket.js";
import Bus from "@/assets/js/bus.js";
import Cookies from "js-cookie";
import $store from "@/store/index.js";
import $ from 'jquery';
import axios from 'axios';
import i18n from '@/lang';
import { returnStrByInfo } from '@/assets/js/filter.js';
function spaceControl(e) {
  if (e.keyCode === 32) {
    $store.state.spaceBarControl = !$store.state.spaceBarControl;
  }
}
// 添加对空格键的按键监听
const spaceListener = function () {
  document.removeEventListener('keyup', spaceControl);
  document.addEventListener('keyup', spaceControl);
};

//返回32位随机数
const return32Str = function (length = 22) {
  var chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
  var num = "";
  for (var i = 0; i < length; i++) {
    let id = parseInt(Math.random() * 61);
    num += chars[id];
  }
  return 'Partyline_' + num;
};
function message(event) {
  let module = "";
  let result = {};
  let origin = '';
  if (typeof event === "object") {
    module = event.module;
    result = event.result;
    origin = event.origin;
  } else {
    module = JSON.parse(event).module;
    result = JSON.parse(event).result;
    origin = JSON.parse(event).origin;
  }
  switch (module) {
    case "mainWindowSetting":
      Bus.$emit("mainWindowSetting", result);
      break;
    case "flipVideo":
      Bus.$emit("flipVideo", result);
      break;
    case "listCurrentDevice":
      Bus.$emit("refreshSourceStatus", result);
      break;
    case "setCrew":
      Bus.$emit("setCrew", result);
      break;
    case "cancelCrew":
      Bus.$emit("cancelCrew", result);
      break;
    case "startPrivateConversation":
      Bus.$emit("startPrivateConversation", result);
      break;
    case "cancelPrivateConversation":
      Bus.$emit("cancelPrivateConversation", {
        origin,
        ...result
      });
      break;
    case "setUserKkvs":
      Bus.$emit('setUserKkvs', result);
      break;
    case "shareScreen":
      Bus.$emit("shareScreen", result);
      break;
    case "cancelShareScreen":
      Bus.$emit("cancelScreen", result);
      break;
    case "setOutput":
      Bus.$emit("setOutput", result);
      break;
    case "cancelOutput":
      Bus.$emit("cancelOutput", result);
      break;
    case "removeParticipant":
      Bus.$emit("removeParticipant", result);
      break;
    case "switchParty":
      Bus.$emit("switchParty", result);
      break;
    case "groupRtilCodes":
      Bus.$emit("groupRtilCodes", result);
      break;
    case "setBehaviors":
      Bus.$emit("setBehaviors", result);
      break;
    case "endParty":
      Bus.$emit("endParty", result);
      break;
    case "netStatus":
      Bus.$emit("netStatus", result);
      break;
    case "raiseHand":
      Bus.$emit("raiseHand", result);
      break;
    case "denyRaiseHand":
      Bus.$emit("denyRaiseHand", result);
      break;
    case "joinStatus":
      Bus.$emit("joinStatus", result);
      break;
    case "videoQuality":
      Bus.$emit("videoQuality", result);
      break;
    case "setSpeaker":
      Bus.$emit("setSpeaker", result);
      break;
    case "cancelSpeaker":
      Bus.$emit("cancelSpeaker", result);
      break;
    case "setQuestioner":
      Bus.$emit("setQuestioner", result);
      break;
    case "cancelQuestioner":
      Bus.$emit("cancelQuestioner", result);
      break;
    case "setQuestionSpeaker":
      Bus.$emit("setQuestionSpeaker", result);
      break;
    case "cancelQuestionSpeaker":
      Bus.$emit("cancelQuestionSpeaker", result);
      break;
    case "online":
      Bus.$emit("online", result);
      break;
    case "offline":
      Bus.$emit("offline", result);
      break;
    case "setPartyTitle":
      Bus.$emit("setPartyTitle", result);
      break;
    case "rejoin":
      Bus.$emit("rejoin", result);
      break;
    case "setNoSubscribeRtil":
      Bus.$emit("setNoSubscribeRtil", result);
      break;
    case "questionerList":
      Bus.$emit("questionerList", result);
      break;
    case "changeLayout":
      Bus.$emit("changeLayout", result);
      break;
    case "notify":
      Bus.$emit("notify", result);
      break;
    case "managerOnline":
      Bus.$emit("managerOnline", result);
      break;
    case "rtilLiveStatus":
      Bus.$emit("rtilLiveStatus", result);
      break;
    case "showSlotText":
      Bus.$emit("showSlotText", result);
      break;
    case "cancelShowSlotText":
      Bus.$emit("cancelShowSlotText", result);
      break;
    case "slotChange":
      Bus.$emit("slotChange", result);
      break;
    case "sectionSlotNum":
      Bus.$emit("sectionSlotNum", result);
      break;
    case "unlock":
      Bus.$emit("unlock", result);
      break;
    case "bindCohost":
      Bus.$emit("bindCohost", result);
      break;
    case "cancelPreview":
      Bus.$emit("cancelPreview", result);
      break;
    case "startAudioMix":
      Bus.$emit('startAudioMix', result);
      break;
    case "stopAudioMix":
      Bus.$emit('stopAudioMix', result);
      break;
    case "lockName":
      Bus.$emit('lockName', result);
      break;
    case "unlockName":
      Bus.$emit('unlockName', result);
      break;
    case "moveParticipants":
      Bus.$emit('moveParticipants', result);
      break;
    case "cancelParticipantTalkBack":
      Bus.$emit('cancelParticipantTalkBack', result);
      break;
    case "setParticipantTalkBack":
      Bus.$emit('setParticipantTalkBack', result);
      break;
    case "cancelTalkBack":
      Bus.$emit('cancelTalkBack', result);
      break;
    case "setTalkBack":
      Bus.$emit('setTalkBack', result);
      break;
    case "setCopyButton":
      Bus.$emit('setCopyButton', result);
      break;
    case "cancelCopyButton":
      Bus.$emit('cancelCopyButton', result);
      break;
    case "button":
      Bus.$emit('setLoginScreenButton', result);
      break;
    case "setFreeTalk":
      Bus.$emit('setFreeTalk', result);
      break;
    case "cancelFreeTalk":
      Bus.$emit('cancelFreeTalk', result);
    case "startVoIP":
      Bus.$emit('startVoIP', result);
      break;
    case "stopVoIP":
      Bus.$emit('stopVoIP', result);
      break;
    case "setPrivateTextChat":
      Bus.$emit('setPrivateTextChat', result);
      break;
    case "cancelPrivateTextChat":
      Bus.$emit('cancelPrivateTextChat', result);
      break;
    case "setPublicTextChat":
      Bus.$emit('setPublicTextChat', result);
      break;
    case "cancelPublicTextChat":
      Bus.$emit('cancelPublicTextChat', result);
      break;
    case "partyOnlineStatus":
      Bus.$emit('partyOnlineStatus', result);
      break;
    case "setBackground":
      Bus.$emit('setBackground', result);
      break;
    case "clearNotInvited":
      Bus.$emit('clearNotInvited', result);
      break;
    case "clearRemovedInvited":
      Bus.$emit('clearRemovedInvited', result);
      break;
    case "setLogos":
      Bus.$emit('setLogos', result);
      break;
    case "viewPosition":
      Bus.$emit('viewPosition', result);
      break;
    case "setCompanyLogo":
      Bus.$emit('setCompanyLogo', result);
      break;
    case "cancelCompanyLogo":
      Bus.$emit('cancelCompanyLogo', result);
      break;
    case "viewPositionV2":
      Bus.$emit('viewPositionV2', result);
      break;
    case "controlBehavior":
      Bus.$emit('controlBehavior', result);
      break;
    case "responseControlBehavior":
      Bus.$emit('responseControlBehavior', result);
      break;
    case "collaborateInvite":
      Bus.$emit('collaborateInvite', result);
      break;
    case "audioOn":
      Bus.$emit('audioOn', result);
      break;
    case "audioOff":
      Bus.$emit('audioOff', result);
      break;
    case "talkOn":
      Bus.$emit('talkOn', result);
      break;
    case 'talkOff':
      Bus.$emit('talkOff', result);
      break;
    case "audioMatrix":
      Bus.$emit('audioMatrix', result);
      break;
    case "deleteCollaborateInvite":
      Bus.$emit('deleteCollaborateInvite', result);
      break;
    case "fullScreenFromGlobalControl":
      Bus.$emit('fullScreenFromGlobalControl', result);
      break;
    case "startPushStreamFromGlobalControl":
      Bus.$emit('startPushStreamFromGlobalControl', result);
      break;
    case "stopPushStreamFromGlobalControl":
      Bus.$emit('stopPushStreamFromGlobalControl', result);
      break;
    case "muteFromGlobalControl":
      Bus.$emit('muteFromGlobalControl', result);
      break;
    case "addToGlobalControl":
      Bus.$emit('addToGlobalControl', result);
      break;
    case "removeFromGlobalControl":
      Bus.$emit('removeFromGlobalControl', result);
      break;
    case "applyStreamForAll":
      Bus.$emit('applyStreamForAll', result);
      break;
    case "stopPullStream":
      Bus.$emit('stopPullStream', result);
      break;
    case "shareScreenSetting":
      Bus.$emit('shareScreenSetting', result);
      break;
    case "startStt":
      Bus.$emit('startStt', result);
      break;
    case "stopStt":
      Bus.$emit('stopStt', result);
      break;
    case "setVoiceCommandProduction":
      Bus.$emit('setVoiceCommandProduction', result);
      break;
    case "pushToTalk":
      Bus.$emit('pushToTalk', result);
      break;
    case "intercom":
      Bus.$emit('intercom', result);
      break;
    case "intercomPro":
      Bus.$emit('intercomPro', result);
  }
}
const errorCallback = {
  "800213": () => {}
};
const options = {
  message,
  errorCallback
};
function createWs(url) {
  var ws = Socket(url, options);
  return ws;
}
function GMTtoUTC() {
  let d = new Date();
  let year = d.getUTCFullYear();
  let month = d.getUTCMonth() + 1 < 10 ? `0${d.getUTCMonth() + 1}` : d.getUTCMonth() + 1;
  let date = d.getUTCDate() < 10 ? `0${d.getUTCDate()}` : d.getUTCDate();
  let hours = d.getUTCHours() < 10 ? `0${d.getUTCHours()}` : d.getUTCHours();
  let mins = d.getUTCMinutes() < 10 ? `0${d.getUTCMinutes()}` : d.getUTCMinutes();
  let seconds = d.getUTCSeconds() < 10 ? `0${d.getUTCSeconds()}` : d.getUTCSeconds();
  return `${year}-${month}-${date}T${hours}:${mins}:${seconds}Z`;
}
// 检查并移除字符串partyCode中的重复部分
export function removeDuplicateSegments(value, length) {
  if (!value || value.length !== length) return value;
  const segmentLength = length / 2;
  const firstPart = value.substring(0, segmentLength);
  const secondPart = value.substring(segmentLength);

  // 如果前后两段一样，则只保留前一段
  if (firstPart === secondPart) {
    return firstPart;
  }
  return value;
}
const judgeVerticalScreen = function () {
  const width = document.body.clientWidth;
  const height = document.body.clientHeight;
  if (width / height < 1) {
    $store.state.isVertical = true;
    return true;
  } else {
    $store.state.isVertical = false;
    return false;
  }
};
const dynamicLoadJs = function (url, callback, id) {
  var head = document.getElementsByTagName("body")[0];
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.id = id || "";
  script.src = url;
  if (typeof callback == "function") {
    script.onerror = () => {
      callback && callback("failed");
    };
    script.onload = () => {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        callback && callback("true");
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(script);
};
const setTagCookie = (tagKey, tagValue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = d.toUTCString();
  let domain = document.domain.split('.');
  domain = `${domain[1]}.${domain[2]}`;
  if (tagKey && tagValue) {
    //字符串拼接cookie
    window.document.cookie = tagKey + "=" + tagValue + ";path=/;domain=" + domain + ";expires=" + expires;
  }
};
export function handleLocalStorage(action, key, value) {
  // 检查浏览器是否支持 localStorage
  if (typeof Storage !== 'undefined') {
    // 根据 action 判断是设置还是获取数据
    if (action === 'set' && key !== undefined && value !== undefined) {
      var _localStorage;
      // 检查 value 是否已经是字符串，如果不是，则转换为字符串
      let stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      // 设置 localStorage 的值
      (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(key, stringValue);
    } else if (action === 'get' && key !== undefined) {
      // 获取指定 key 的 localStorage 值
      return localStorage.getItem(key);
    } else if (action === 'remove' && key !== undefined) {
      localStorage.removeItem(key);
    } else {
      // 参数不足或 action 不符合要求
      console.error("Invalid arguments or action.");
      return null;
    }
  } else {
    // 浏览器不支持 localStorage
    console.error("LocalStorage is not supported by this browser.");
    return null;
  }
}
const removeHostLoginInfo = function () {
  if (!$store.state.hasLogin && localStorage.getItem('isHost')) {
    // 清除之前与会者以host的身份登录的登录信息，
    localStorage.removeItem('memberId');
    localStorage.removeItem('rtilCode');
    localStorage.removeItem('isHost');
  }
};
// 控制与会者的hotJar的显示和隐藏
const showPipHotJar = function (isShowHotJar) {
  let hotJarNum = 0;
  const hotJarTimer = setInterval(() => {
    hotJarNum++;
    const hotJarIcon = $('._hj_feedback_container');
    if (hotJarIcon.length > 0) {
      clearInterval(hotJarTimer);
      hotJarIcon.css({
        display: isShowHotJar ? 'block' : 'none'
      });
    }
    if (hotJarNum > 1000 && hotJarIcon.length <= 0) {
      clearInterval(hotJarTimer);
    }
  }, 100);
};
const showChatlio = function (val) {
  const chatlioIcon = $('.chatlio-widget');
  chatlioIcon.css({
    display: val ? 'block' : 'none'
  });
};
function timestampToTime(timestamp) {
  const date = new Date(timestamp);
  const Y = date.getFullYear() + '-';
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  const D = date.getDate() + ' ';
  return Y + M + D;
}
function useEventListener(target, event, callback) {
  onMounted(() => target.addEventListener(event, callback));
  onUnmounted(() => target.removeEventListener(event, callback));
}
export function useMove(callback) {
  const x = ref(0);
  const y = ref(0);
  useEventListener(window, 'mousemove', event => {
    x.value = event.pageX;
    y.value = event.pageY;
    const element = event.target;
    if (element) {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      sendPosition({
        x,
        y,
        screenWidth,
        screenHeight
      });
    }
  });
  return callback({
    x,
    y
  });
}
function sendPosition({
  x,
  y,
  screenWidth,
  screenHeight
}) {
  const params = {
    partyCode: '746933411446',
    module: 'notify',
    msg: {
      key: 'mousePosition',
      position: {
        x: x.value,
        y: y.value
      },
      email: $store.state.loginInfo.email,
      id: $store.state.loginInfo.id,
      screenWidth,
      screenHeight
    }
  };
  axios.post('/partyline-backend/party/noLogin/command?key=95582', params).then(async res => {});
}
export function addTabTitle(info) {
  const {
    userInfo,
    useTime
  } = info;
  if (!userInfo) return;
  let name = '';
  if (userInfo.title || userInfo.partyName) {
    name = userInfo.title || userInfo.partyName;
  } else {
    if (useTime) {
      name = new Date(userInfo.startPartyTime || userInfo.createTime).toLocaleDateString() + '   ' + new Date(userInfo.startPartyTime || userInfo.createTime).toLocaleTimeString();
    } else {
      name = returnStrByInfo(userInfo.joinCode, userInfo.joinCode.length === 9 ? 3 : 4);
    }
  }
  document.title = i18n.t('common.partyTitle', {
    name
  });
}
export function replaceDuplicateKey(key, str) {
  // 使用正则表达式匹配关键词，忽略大小写，并设置全局搜索标志
  const pattern = new RegExp(key, 'gi');
  let isRepeat = false;
  let isFirstOccurrence = true; // 用于标记是否为第一次出现
  const strVal = str.replace(pattern, match => {
    if (isFirstOccurrence) {
      // 如果是第一次出现，则保留该关键词，不做替换
      isFirstOccurrence = false; // 更新标记
      return match;
    } else {
      isRepeat = true;
      // 从第二次出现开始，替换为为空字符串
      return '';
    }
  });
  return {
    val: isRepeat,
    strVal
  };
}
export function returnSourceType(item, outputRtilCode, rtilCode) {
  let type = 'Web';
  if (!item) return type;
  const {
    deviceType,
    accountId
  } = item;
  if (deviceType === 'R') {
    type = 'R';
  } else if (deviceType === 'T') {
    if (Number(item.devicePlatform) >= 10 && Number(item.devicePlatform) <= 14) {
      type = 'Anywhere';
    } else {
      type = 'T';
    }
  } else if (accountId.includes('partylineapp')) {
    type = 'App';
  }
  return type;
}
export default {
  showPipHotJar,
  showChatlio,
  return32Str,
  createWs,
  GMTtoUTC,
  judgeVerticalScreen,
  spaceListener,
  dynamicLoadJs,
  setTagCookie,
  message,
  removeHostLoginInfo,
  timestampToTime,
  useEventListener,
  handleLocalStorage,
  returnSourceType,
  removeDuplicateSegments
};